module.exports = __webpack_public_path__ + "static/img/s-oppo-5.aa9f7fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/clac/img/s-oppo-5.png
// module id = 9ejB
// module chunks = 1